import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import logoLight from '../../../assets/site/ds360-logo-light.png';
import Icon from '../components/Icon';
import { contact } from '../data/contact';
import { disclosure, footerColumns } from '../data/content';
import { GRADIENTS, skylineBackground } from '../utils/skyline';
import ui from '../styles/primitives.module.css';
import styles from './Footer.module.css';

const FOOTER_SKYLINE = {
  seed: 81,
  gradient: GRADIENTS.night,
  layers: [
    { w: [70, 130], h: [100, 240], fill: '#0a1e1c' },
    { w: [60, 110], h: [50, 140], fill: '#030807' },
  ],
};

const FooterLink = ({ link }) =>
  link.href ? (
    <a href={link.href} target="_blank" rel="noopener noreferrer">
      {link.label}
    </a>
  ) : (
    <Link to={link.to}>{link.label}</Link>
  );

const Footer = () => {
  const background = useMemo(() => skylineBackground(FOOTER_SKYLINE), []);

  return (
    <footer className={styles.footer} style={{ backgroundImage: background }}>
      <div className={ui.wrap}>
        <div className={styles.grid}>
          <div>
            <img className={styles.logo} src={logoLight} alt="DS360 Investment — Building Wealth Rebuilding Cities" />
            <ul className={styles.contact}>
              <li>
                <Icon name="phone" />
                <a href={contact.phoneHref}>{contact.phoneDisplay}</a>
              </li>
              <li>
                <Icon name="mail" />
                <a href={contact.emailHref}>Contact Us: {contact.email}</a>
              </li>
            </ul>
          </div>

          {footerColumns.map((column) => (
            <nav key={column.title} className={styles.column} aria-label={column.title}>
              <h2>{column.title}</h2>
              <ul>
                {column.links.map((link) => (
                  <li key={link.label}>
                    <FooterLink link={link} />
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <p className={styles.disclosure}>{disclosure}</p>
      </div>
    </footer>
  );
};

export default Footer;
